<script lang="ts">
	import { page } from '$app/stores';
	import { Home, Users, Crown, BarChart3, User, Search, Tv, Calendar, Newspaper, Grid, Info, Rocket } from 'lucide-svelte';
	import { onMount } from 'svelte';
	import { supabase } from '$lib/supabase';
	import { authStore } from '$lib/stores/authStore';
	import { _, locale } from 'svelte-i18n';
	import { t as translate } from '$lib/i18n';
	import { cn } from "$lib/components/shadcn/utils";
	import { buttonVariants } from "$lib/components/shadcn/ui/button";
	import { Separator } from "$lib/components/shadcn/ui/separator";
	import { ScrollArea } from "$lib/components/shadcn/ui/scroll-area";

	// メニュー項目を定義（リアクティブに更新されるように$:を使用）
	$: navItems = [
		{ href: '/', label: translate('sidebar.top', 'トップ'), icon: Home },
		{ href: '/live-rankings', label: translate('sidebar.live_rankings', '配信中ランキング'), icon: BarChart3  },
		{ href: '/channel-rankings', label: translate('sidebar.channel_rankings', 'チャンネルランキング'), icon: Crown},
		{ href: '/group/1', label: translate('sidebar.groups', 'グループ一覧'), icon: Users },
		{ href: '/multiview', label: translate('sidebar.multiview', 'マルチビュー'), icon: Grid },
		{ href: '/schedule', label: translate('sidebar.schedule', '番組表'), icon: Tv },
		{ href: '/search', label: translate('sidebar.search', '検索'), icon: Search },
		{ href: '/channels', label: translate('sidebar.channels', 'チャンネル一覧'), icon: Users },
		{ href: '/articles', label: translate('sidebar.articles', 'まとめアンテナ'), icon: Newspaper },
		{ href: '/daily-articles', label: translate('sidebar.daily_articles', 'ブログ'), icon: Newspaper },
	];

	let user = null;

	export let isSidebarOpen: boolean;
	export let toggleSidebar: () => void;

	onMount(async () => {
		supabase.auth.onAuthStateChange((event, session) => {
			user = session?.user;
		});
	});
</script>

<div class="fixed inset-0 z-30 md:hidden {isSidebarOpen ? 'block' : 'hidden'}" on:click={toggleSidebar}>
	<div class="absolute inset-0 bg-zinc-950/10 backdrop-blur-sm" />
</div>

<aside 
	class="h-[calc(100vh-3.5rem)] bg-zinc-100 dark:bg-zinc-900 border-r fixed top-16 left-0 z-40 overflow-hidden transition-all duration-300 {isSidebarOpen ? 'w-64' : 'w-0 md:w-14'} {isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}"
>
	<ScrollArea class="h-full">
		<div class="py-4 px-2">
			<nav class="space-y-1">
				{#each navItems as item}
					<a
						href={item.href}
						class={cn(
							buttonVariants({ variant: "ghost", size: "sm" }),
							"w-full justify-start",
							$page.url.pathname === item.href ? "bg-muted hover:bg-muted" : "",
							isSidebarOpen ? "px-2" : "px-0 justify-center"
						)}
						aria-current={$page.url.pathname === item.href ? "page" : undefined}
					>
						<svelte:component this={item.icon} class="h-4 w-4" />
						<span class="ml-2 transition-all duration-300 {isSidebarOpen ? 'opacity-100' : 'opacity-0 md:hidden'} overflow-hidden truncate">
							{item.label}
						</span>
					</a>
				{/each}
			</nav>
			
			<Separator class="my-4" />
			
			<div class="py-2">
				<h2 class="mb-2 text-xs font-semibold tracking-tight text-muted-foreground transition-all {isSidebarOpen ? 'opacity-100' : 'opacity-0 md:hidden'}">
					{translate('sidebar.system', 'システム')}
				</h2>
				<div class="space-y-1">
					<a 
						href="/about" 
						class={cn(
							buttonVariants({ variant: "ghost", size: "sm" }),
							"w-full justify-start",
							$page.url.pathname === '/about' ? "bg-muted hover:bg-muted" : "",
							isSidebarOpen ? "px-2" : "px-0 justify-center"
						)}
					>
						<Info class="h-4 w-4" />
						<span class="ml-2 transition-all duration-300 {isSidebarOpen ? 'opacity-100' : 'opacity-0 md:hidden'} overflow-hidden truncate">
							{translate('footer.links.about', 'サービスについて')}
						</span>
					</a>
					
					<a 
						href="/vtuber-partnership" 
						class={cn(
							buttonVariants({ variant: "ghost", size: "sm" }),
							"w-full justify-start",
							$page.url.pathname === '/vtuber-partnership' ? "bg-muted hover:bg-muted" : "",
							isSidebarOpen ? "px-2" : "px-0 justify-center",
							"mt-2"
						)}
					>
						<Rocket class="h-4 w-4 text-indigo-500" />
						<span class="ml-2 transition-all duration-300 {isSidebarOpen ? 'opacity-100' : 'opacity-0 md:hidden'} overflow-hidden truncate">
							VTuberサポート
						</span>
					</a>
				</div>
			</div>
		</div>
	</ScrollArea>
</aside>
